import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SwitchModule } from '@progress/kendo-angular-inputs';
import { SidebarService } from '../../core/services/sidebar.service';
import { AuthService } from '../../core/auth/services/auth.service';
import { DialogService } from '../../core/services/dialog.service';

@Component({
  selector: 'app-header',
  imports: [RouterLink, SwitchModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {

  private authService = inject(AuthService);
  private dialogService = inject(DialogService);
  public sidebar = inject(SidebarService);
  readonly username = inject(AuthService).username;

  appName = signal('Legajos Técnicos');
  logoUrl = signal('assets/icons/pampa_energa_logo.svg');
  menuOpen = signal(false);

  isDarkMode =  signal(this.readInitialTheme());
  readonly initials = computed(() => {
    const name = this.username();
    if (!name) return '';

    const words = name.trim().split(' ');
    const firstInitial = words[0]?.charAt(0).toUpperCase() || '';
    const lastInitial = words[words.length - 1]?.charAt(0).toUpperCase() || '';
    return `${firstInitial}${lastInitial}`;
  });

  constructor() {
    effect(() => {
      const dark = this.isDarkMode();

      document.documentElement.classList.remove('dark');
      // Telerik
      document.body.classList.toggle('k-theme-dark', dark);

      // Bootstrap 5.3 (variables)
      document.documentElement.setAttribute('data-bs-theme', dark ? 'dark' : 'light');

      // Persistencia
      localStorage.setItem('theme', dark ? 'dark' : 'light');
      if(dark){
        document.documentElement.classList.add( dark ? 'dark' : 'light');
        return;
      }
    });
  }

  async logout() {
    const ok = await this.dialogService.confirm('Cerrar sesión', '¿Está seguro de que desea cerrar la sesión?');
    if (ok) this.authService.logout();
  }

  toggleMenu() {
    this.menuOpen.update(v => !v);
  }

  onThemeChange(checked: boolean) {
    this.isDarkMode.update(darkMode => checked);
  }

  private readInitialTheme(): boolean {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark' || saved === 'light') return saved === 'dark';
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  }
}
